import { type ChangeEvent, type RefObject, useLayoutEffect, useRef, } from "react";

type TOnChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>) => void;

export const useFormatedInputCursor = (
  inputRef: RefObject<HTMLInputElement | null>,
  formatter: (value: string) => string,
) => {
  const cursorPositionRef = useRef<number | null>(null);

  useLayoutEffect(() => {
    if (cursorPositionRef.current !== null && inputRef.current) {
      inputRef.current.setSelectionRange(cursorPositionRef.current, cursorPositionRef.current);
      cursorPositionRef.current = null;
    }
  });

  const formatedInputOnChange = (originalOnChange?: TOnChange): TOnChange =>
    (e) => {
      const inputEl = e.target as HTMLInputElement;
      const raw = inputEl.value;
      const cursor = inputEl.selectionEnd ?? raw.length;
      const formatted = formatter(raw);
      inputEl.value = formatted;

      if (formatted !== raw) {
        const digitsBeforeCursor = raw.slice(0, cursor).replace(/\D/g, "").length;
        let digitCount = 0;
        let newCursor = digitsBeforeCursor === 0 ? 0 : formatted.length;
        for (let i = 0;i < formatted.length;i++) {
          if (/\d/.test(formatted[i])) {
            digitCount++;
            if (digitCount === digitsBeforeCursor) {
              newCursor = i + 1;
              break;
            }
          }
        }
        cursorPositionRef.current = newCursor;
      }

      originalOnChange?.(e);
    };

  return { formatedInputOnChange };
};
